import MediaImage from "@/components/ui/MediaImage";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAddressCard } from "@fortawesome/sharp-light-svg-icons";
import VCard from "vcard-creator";
import Link from "next/link";
import { CaseData } from "@/cms/models";

interface StoreContactDetailsProps {
  caseData: CaseData;
  /** The details stand on the section's background, so they take its own text colour instead of the card's. */
  followsSectionText?: boolean;
}

const StoreContactDetails: React.FC<StoreContactDetailsProps> = ({
  caseData,
  followsSectionText = false,
}) => {
  const storeDisplayName = caseData.resourceGroup?.displayName;
  const storePhone = caseData.resourceGroup?.phone;
  const storePhoneFormatted = caseData.resourceGroup?.formattedPhone;
  const storeEmail = caseData.resourceGroup?.email;
  const storeImageUrl = caseData.resourceGroup?.images.find(
    (x: any) =>
      x.namespace === "dk.realequity.mediaitem.image.resourcegroup.homepage",
  )?.lgUrl;

  return (
    <div
      className={
        followsSectionText
          ? "homepage-text-sm text-[var(--section-text-color)]"
          : "homepage-text-sm text-[var(--card-text-color)]"
      }
      data-component-type="StoreContactDetails"
    >
      <div
        data-image={!!storeImageUrl}
        className="h-80 relative data-[image=true]:flex hidden"
      >
        <MediaImage
          src={storeImageUrl!}
          alt="agent image"
          loading="eager"
          className="object-cover w-full h-full absolute inset-0"
        />
      </div>
      <div className=" flex flex-col gap-2 py-4 ">
        <div className="flex gap-2 justify-between">
          <div>
            <div className="homepage-text-lg">{storeDisplayName}</div>
          </div>
          <button
            className="flex"
            aria-label="vcard"
            onClick={() => {
              const vCard = new VCard();
              vCard.addName(storeDisplayName);
              if (storePhone) {
                vCard.addPhoneNumber(storePhone, "CELL;VOICE");
              }
              if (storeImageUrl) {
                vCard.addPhotoURL(storeImageUrl);
              }
              if (storeEmail) {
                vCard.addEmail(storeEmail);
              }
              const blob = new Blob([vCard.toString()], {
                type: "text/vcard",
              });
              const url = URL.createObjectURL(blob);
              const link = document.createElement("a");
              link.href = url;
              link.download = `${storeDisplayName}.vcf`;
              link.click();
              URL.revokeObjectURL(url);
            }}
          >
            <FontAwesomeIcon
              className="size-7 md:size-5"
              icon={faAddressCard}
            />
          </button>
        </div>
        <div>
          <Link aria-label="Phone" className="block" href={`tel:${storePhone}`}>
            {storePhoneFormatted}
          </Link>
          <Link
            aria-label="Email"
            className="block"
            href={`mailto:${storeEmail}`}
          >
            {storeEmail}
          </Link>
        </div>
      </div>
    </div>
  );
};

export default StoreContactDetails;
